import request from '@/utils/requestCenter'

const reqPrefix = '/youngbook/lsMallUser/fuelApi/fuel/apply'

//根据当前用户获取车牌号
export function getDriverByPhone(phone) {
  return request({
    method: 'get',
    url: `${reqPrefix}/driver/${phone}`
  })
}

// 获取运单列表
export function consignmentList(plateNumber) {
  return request({
    method: 'get',
    url: `${reqPrefix}/consignmentList/${plateNumber}`
  })
}

//通过车牌号和手机号获取运单列表(新)
export function consignmentListByPlateNumberAndPhone(plateNumber,phone) {
  return request({
    method: 'get',
    url: `${reqPrefix}/consignmentListByPlateNumberPhone/${plateNumber}/${phone}`
  })
}

// 查询司机未确认的运单
export function searchDriverNoConfirm(userId) {
  return request({
    method: 'get',
    url: `${reqPrefix}/searchDriverNoConfirm/${userId}`
  })
}

//查询司机未确认的运单(新)
export function getDriverNoConfirm(plateNumber,phone) {
  return request({
    method: 'get',
    url: `${reqPrefix}/driverNoConfirm/${phone}/${plateNumber}`
  })
}

//获取所有的燃油类型
export function queryAllFuelTypes() {
  return request({
    method: 'get',
    url: `${reqPrefix}/getAllFuelTypes`
  })
}

//根据运单项目名获取该项目当前可用的燃油
export function getAllUsageFuelTypesByProjectName(projectName) {
  return request({
    method: 'get',
    url: `${reqPrefix}/getAllUsageFuelTypesByProjectName/`+projectName
  })
}

//申请加油(新)
export function applyAddFuel(data) {
  return request({
    url: `${reqPrefix}/applyAddFuel`,
    method: 'post',
    data: data
  })
}


// 司机确认
export function driverConfirm(id) {
  return request({
    method: 'get',
    url: `${reqPrefix}/driverConfirm/${id}`
  })
}



// 历史记录
export function applyHistory(data) {
  return request({
    method: 'post',
    url: `${reqPrefix}/applyHistory`,
    data: data
  })
}

//根据运单Id数组和燃油类型初步计算总额和升数
export function getFuelMoneyAndLiter(data) {
  return request({
    method: 'post',
    url: `${reqPrefix}/getFuelMoneyAndLiter`,
    data: data
  })
}

//根据当前用户获取车牌号列表
export function getFuelPlateNumberListByPhone(phone) {
  return request({
    method: 'get',
    url: `${reqPrefix}/carList/${phone}`
  })
}

//历史记录去到详情页
export function historyGoFuelDetails(id) {
  return request({
    method: 'get',
    url: `${reqPrefix}/getApplyById/${id}`
  })
}

let x = '/youngbook/lsMallUser/fuelApi/selfFuel/apply'
//查询车牌号列表
export function carNumbers(query) {
    return request({
      method: 'get',
      url: `${x}/carPlateNumbers`,
      params:query
    })
  }
//查询可加金额
export function carMoney(id) {
    return request({
      method: 'get',
      url: `${x}/usableQuotaLitre/${id}`
    })
  }

//历史记录
export function historyFuelDetails(id,data) {
    return request({
      method: 'get',
      url: `${x}/history/${id}`,
      data: data
      
    })
  }

  //当前油价
  export function fuelMoney() {
    return request({
      method: 'get',
      url: `${x}/currentFuelPrice`
    })
  }

  //申请加油
  export function applyFuel(data) {
    return request({
      method: 'post',
      url: `${x}/applyFuel`,
      data: data
    })
  }
  //查询未确认的加注申请
  export function noConfirmApply() {
    return request({
      method: 'get',
      url: `${x}/noConfirmApply`,
    })
  }

  //确认
  export function confirmApply(id) {
    return request({
      method: 'put',
      url: `${x}/confirmApply/${id}`,
    })
  }
    //疑问
    export function driverQuestion(data) {
      return request({
        method: 'put',
        url: `${x}/driverQuestion`,
        data
      })
    }
  
    //查询申请状态
    export function verifyConfirm(id){
      return request({
        method: 'get',
        url: `${x}/verifyConfirm/${id}`,
      })
    }
  
 
